export default "__VITE_ASSET__BQ7uvBzU__"